export const WORKSPACE_OUTSIDE_ROOM_ERROR_CODE = 'WORKSPACE_OUTSIDE_ROOM';
export const WORKSPACE_CROSSES_WALL_ERROR_CODE = 'WORKSPACE_CROSSES_WALL';

export const isWorkspaceRoomBoundsErrorCode = (errorCode: string | undefined): boolean =>
  errorCode === WORKSPACE_OUTSIDE_ROOM_ERROR_CODE || errorCode === WORKSPACE_CROSSES_WALL_ERROR_CODE;

export const getApiErrorCode = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return undefined;
  }

  const response = (error as {response?: {data?: {error_code?: unknown}}}).response;
  const errorCode = response?.data?.error_code;

  return typeof errorCode === 'string' ? errorCode : undefined;
};
